import { getMaterialsAnalytics } from '../../api/analytics';
import {
  getMercoTimerCycleHistory,
  getMercoTimerCycleHistoryTotal,
  exportMercoTimerCycleHistory,
  deleteMercoTimerCycle,
  getAvailableProducts,
} from '../../api/mercoTimerCycleHistory';
import { downloadFile } from '../../utils';
import { handleActionAbortController } from '../../utils/handleActionAbortController';

export const CHANGE_MERCO_TIMER_CYCLE_HISTORY_VALUE = 'CHANGE_MERCO_TIMER_CYCLE_HISTORY_VALUE';
export const CHANGE_MERCO_TIMER_CYCLE_HISTORY_SEVERAL_VALUES = 'CHANGE_MERCO_TIMER_CYCLE_HISTORY_SEVERAL_VALUES';
export const RESET_MERCO_TIMER_CYCLE_HISTORY_STORE = 'RESET_MERCO_TIMER_CYCLE_HISTORY_STORE';

export const GET_MERCO_TIMER_CYCLE_HISTORY = 'GET_MERCO_TIMER_CYCLE_HISTORY';
export const GET_MERCO_TIMER_CYCLE_HISTORY_SUCCESS = 'GET_MERCO_TIMER_CYCLE_HISTORY_SUCCESS';
export const GET_MERCO_TIMER_CYCLE_HISTORY_ERROR = 'GET_MERCO_TIMER_CYCLE_HISTORY_ERROR';

export const GET_MERCO_TIMER_CYCLE_HISTORY_ANALYTIC = 'GET_MERCO_TIMER_CYCLE_HISTORY_ANALYTIC';
export const GET_MERCO_TIMER_CYCLE_HISTORY_ANALYTIC_SUCCESS = 'GET_MERCO_TIMER_CYCLE_HISTORY_ANALYTIC_SUCCESS';
export const GET_MERCO_TIMER_CYCLE_HISTORY_ANALYTIC_ERROR = 'GET_MERCO_TIMER_CYCLE_HISTORY_ANALYTIC_ERROR';

export const LOAD_MERCO_TIMER_CYCLE_HISTORY_FILE = 'LOAD_MERCO_TIMER_CYCLE_HISTORY_FILE';
export const LOAD_MERCO_TIMER_CYCLE_HISTORY_FILE_SUCCESS = 'LOAD_MERCO_TIMER_CYCLE_HISTORY_FILE_SUCCESS';
export const LOAD_MERCO_TIMER_CYCLE_HISTORY_FILE_ERROR = 'LOAD_MERCO_TIMER_CYCLE_HISTORY_FILE_ERROR';

export const DELETE_MERCO_TIMER_CYCLE_HISTORY = 'DELETE_MERCO_TIMER_CYCLE_HISTORY';
export const DELETE_MERCO_TIMER_CYCLE_HISTORY_SUCCESS = 'DELETE_MERCO_TIMER_CYCLE_HISTORY_SUCCESS';
export const DELETE_MERCO_TIMER_CYCLE_HISTORY_ERROR = 'DELETE_MERCO_TIMER_CYCLE_HISTORY_ERROR';

export const getFilterProductsAction =
  (actions = {}) =>
  async () => {
    try {
      const response = await getAvailableProducts();
      const { success, results } = response;
      if (success) {
        actions.onSuccess && actions.onSuccess(results);
      }
    } catch (error) {
      actions.onError && actions.onError(error.message);
    }
  };

export const getMercoTimerCycleHistoryAction = (function () {
  let prevController;

  return (params, actions = null) => {
    return async dispatch => {
      const abortController = handleActionAbortController(prevController);
      prevController = abortController;
      dispatch({ type: GET_MERCO_TIMER_CYCLE_HISTORY, payload: params.cursorDirection === 'FIRST' });
      try {
        const response = await getMercoTimerCycleHistory(params, abortController.signal);
        const { success, results } = response;
        if (success && !abortController.signal.aborted) {
          dispatch({ type: GET_MERCO_TIMER_CYCLE_HISTORY_SUCCESS, payload: results, params });
        }
      } catch (error) {
        if (!abortController.signal.aborted) {
          actions?.onError(error.message);
          dispatch({ type: GET_MERCO_TIMER_CYCLE_HISTORY_ERROR, params });
        }
      }
    };
  };
})();

export const getMercoTimerCycleAnalyticAction = (function () {
  let prevController;

  return params => {
    return async dispatch => {
      const abortController = handleActionAbortController(prevController);
      prevController = abortController;
      dispatch({ type: GET_MERCO_TIMER_CYCLE_HISTORY_ANALYTIC, payload: params.cursorDirection === 'FIRST' });
      try {
        const [response, totalResponse] = await Promise.all([
          getMaterialsAnalytics(params, abortController.signal),
          getMercoTimerCycleHistoryTotal(
            {
              startTime: params.startEventTime,
              endTime: params.endEventTime,
              restaurantUuid: params.restaurantsUuid,
              products: params.materials,
            },
            abortController.signal
          ),
        ]);

        const { success, results } = response;
        const { success: totalSuccess, results: total } = totalResponse;

        if (success && totalSuccess && !abortController.signal.aborted) {
          dispatch({
            type: GET_MERCO_TIMER_CYCLE_HISTORY_ANALYTIC_SUCCESS,
            payload: { results, total },
            params,
          });
        }
      } catch (error) {
        if (!abortController.signal.aborted) {
          dispatch({ type: GET_MERCO_TIMER_CYCLE_HISTORY_ANALYTIC_ERROR });
        }
      }
    };
  };
})();

export const downloadMercoTimerCycleHistory = (params, actions) => {
  return async dispatch => {
    dispatch({ type: LOAD_MERCO_TIMER_CYCLE_HISTORY_FILE });
    try {
      const response = await exportMercoTimerCycleHistory(params);
      const { success, results } = response;
      if (success) {
        response.code !== 202 && downloadFile(results, 'application/zip');
        dispatch({ type: LOAD_MERCO_TIMER_CYCLE_HISTORY_FILE_SUCCESS });
        if (actions.onSuccess) {
          actions.onSuccess(response);
        }
      }
    } catch (error) {
      dispatch({ type: LOAD_MERCO_TIMER_CYCLE_HISTORY_FILE_ERROR });
      if (actions.onError) {
        actions.onError(error.message);
      }
    }
  };
};

export const deleteMercoTimerCycleAction = (uuid, actions = null) => {
  return async dispatch => {
    dispatch({ type: DELETE_MERCO_TIMER_CYCLE_HISTORY });
    try {
      const response = await deleteMercoTimerCycle(uuid);
      const { success } = response;
      if (success) {
        actions?.onSuccess();
        dispatch({ type: DELETE_MERCO_TIMER_CYCLE_HISTORY_SUCCESS });
      }
    } catch (error) {
      actions?.onError(error.message);
      dispatch({ type: DELETE_MERCO_TIMER_CYCLE_HISTORY_ERROR });
    }
  };
};

export const changeValue = (key, value) => ({
  type: CHANGE_MERCO_TIMER_CYCLE_HISTORY_VALUE,
  payload: {
    key,
    value,
  },
});

export const changeSeveralValues = value => ({
  type: CHANGE_MERCO_TIMER_CYCLE_HISTORY_SEVERAL_VALUES,
  payload: value,
});

export const resetStore = () => ({
  type: RESET_MERCO_TIMER_CYCLE_HISTORY_STORE,
});
